/* eslint-disable no-unused-vars */
import './question.scss';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import AnswerBtn from './Components/answer-btn';
import enumQuestionType from 'enums/enum-question-type';
import propTypes from 'prop-types';
import { useRef, useState } from 'react';
import { Checkbox } from '@mui/material';

export default function Question(props) {
  const [selectedAnswer, setSelectedAnswer] = useState(props.answer);
  const [checked, setChecked] = useState(false);
  const [checklistAnswers, setChecklistAnswers] = useState(
    props.answer.length > 1 ? props.answer.split(',') : []
  );
  const [minutesTimeInputValue, setMinutesTimeInputValue] = useState(
    props.answer.split(':')[2] || ''
  );
  const [hoursTimeInputValue, setHoursTimeInputValue] = useState(
    props.answer.split(':')[1] || ''
  );
  const [daysInputValue, setDaysInputValue] = useState(
    props.answer.split(':')[0] || ''
  );

  const rightTimeInputRef = useRef(null);

  function handleChecklistQuestionOnChange(value, isChecked) {
    let answers = checklistAnswers;
    if (!answers.includes(value) && isChecked) {
      answers.push(value);
      setChecklistAnswers(answers);
    } else {
      answers = answers.filter((a) => a !== value);
      setChecklistAnswers(answers);
    }
    const stringAnswer = answers.join(',');
    props.updateAnswer(stringAnswer);
  }

  function checkValidateTimeInput(timeAnswer) {
    if (timeAnswer === '::') return false;
    const timeArr = timeAnswer.split(':');
    if (timeArr[0] === '') return false;
    if (timeArr[1] === '') return false;
    if (timeArr[2] === '') return false;
    return true;
  }

  function handleTimeInputOnChange(e, side) {
    let answer = `${daysInputValue} - ${hoursTimeInputValue}:${minutesTimeInputValue}`;
    if (side === 'minutes') {
      if (e.target.value > 60) e.target.value = null;
      else {
        setMinutesTimeInputValue(e.target.value.slice(0, 2));
        answer = `${daysInputValue}:${hoursTimeInputValue}:${e.target.value}`;
      }

      // if (e.target.value.length > 1) {
      //     rightTimeInputRef.current.focus();
      // }
    }
    if (side === 'hours') {
      if (e.target.value > 24) e.target.value = null;
      else {
        setHoursTimeInputValue(e.target.value.slice(0, 2));
        answer = `${daysInputValue}:${e.target.value}:${minutesTimeInputValue}`;
      }
    }
    if (side === 'days') {
      if (e.target.value > 7) e.target.value = null;
      else {
        setDaysInputValue(e.target.value.slice(0, 2));
        answer = `${e.target.value}:${hoursTimeInputValue}:${minutesTimeInputValue}`;
      }
    }
    if (checkValidateTimeInput(answer)) props.updateAnswer(answer);
  }

  function getQuestionGroupTitle() {
    switch (props.question.id) {
      case 197:
        return 'האם הנך נטול תרופות קבועות לטיפול ב:';

      case 222:
        return 'האם אתה צורך';

      case 229:
        return 'באיזו תדירות הנך מבצע/ת את הפעילויות הבאות?';

      default:
        return null;
    }
  }

  function ignoreNegativeValues(e) {
    if (e.key.indexOf('-') !== -1) {
      e.preventDefault();
      return;
    }
  }

  function shouldDisplayChildQuestion(parentQuestionId, questionId) {
    if (questionId >= 527 && questionId <= 551)
      if (
        sessionStorage.getItem(`q428`) === 'לא' ||
        sessionStorage.getItem(`q429`) === 'כן' ||
        sessionStorage.getItem(`q430`) === 'כן' ||
        //Less than 6 hours of sleep
        sessionStorage.getItem(`q195`).includes('4')
      )
        return true;
      else return false;

    if (!parentQuestionId) return true;
    if (
      (parentQuestionId === 172 ||
        parentQuestionId === 465 ||
        parentQuestionId === 559) &&
      sessionStorage.getItem(`q${parentQuestionId}`) === 'כן'
    )
      if (questionId === 471 || questionId === 178) {
        if (sessionStorage.getItem(`q2`) === 'נקבה') return true;
        else return false;
      }

    if (parentQuestionId === 185 || parentQuestionId === 425) {
      if (
        (questionId === 186 || questionId === 187) &&
        sessionStorage.getItem(`q${parentQuestionId}`) === 'כן'
      ) {
        return true;
      }
      if (
        (questionId === 425 &&
          sessionStorage.getItem(`q${parentQuestionId}`) === 'לא') ||
        (questionId === 426 &&
          sessionStorage.getItem(`q${parentQuestionId}`) === 'כן')
      ) {
        return true;
      }
      return false;
    }

    const parentQuestionAnswer = sessionStorage.getItem(`q${parentQuestionId}`);
    if (parentQuestionId === 268)
      if (parentQuestionAnswer === 'נקבה') return true;
      else return false;
    if (parentQuestionAnswer)
      return (
        parentQuestionAnswer.trim() !== '' &&
        parentQuestionAnswer.indexOf('לא') === -1
      );
    return false;
  }

  return shouldDisplayChildQuestion(
    props.question.parentQuestionId,
    props.question.id
  ) ? (
    <>
      {getQuestionGroupTitle() !== null && (
        <div className="question-group-title">{getQuestionGroupTitle()}</div>
      )}

      <div
        id={`q${props.question.id}`}
        className={`question 
                 ${props.question.questionType}-question
                ${props.isFocus ? 'focus-err' : ''}
                ${
                  props.question.parentQuestionId !== null
                    ? 'has-parent-question'
                    : ''
                }
                              `}
        style={{
          marginRight:
            props.question.level && props.question.level > 2
              ? 20 * parseInt(props.question.level, 10) + 'px'
              : ''
        }}
      >
        <div className="title">{props.question.text}</div>
        {props.question.questionType !== 'Bool' && (
          <small className="description">{props.question.description}</small>
        )}
        {/* Available answers */}
        {props.question && (
          <>
            {/* Scale */}
            {props.question.questionType === enumQuestionType.Scale && (
              <>
                <Slider
                  min={0}
                  max={JSON.parse(props.question.availableAnswers)?.length}
                  marks={Object.assign(
                    {},
                    [
                      ...JSON.parse(props.question.availableAnswers).map(
                        (question) => question.text
                      ),
                      ''
                    ].reverse()
                  )}
                  step={null}
                  onChange={(answerIndex) => {
                    answerIndex -= 1;
                    props.updateAnswer(
                      JSON.parse(props.question.availableAnswers)[
                        JSON.parse(props.question.availableAnswers)?.length -
                          1 -
                          answerIndex
                      ].text,
                      JSON.parse(props.question.availableAnswers)[
                        JSON.parse(props.question.availableAnswers)?.length -
                          1 -
                          answerIndex
                      ].value
                    );
                  }}
                  defaultValue={
                    JSON.parse(props.question.availableAnswers).findIndex(
                      (t) => t.text === props.answer
                    ) > -1
                      ? JSON.parse(props.question.availableAnswers)?.length -
                        JSON.parse(props.question.availableAnswers).findIndex(
                          (t) => t.text === props.answer
                        )
                      : 0
                  }
                />
              </>
            )}
            {/* Multi Choice */}
            <div className="answers-container">
              {props.question.questionType === enumQuestionType.MultiChoice &&
                JSON.parse(props.question.availableAnswers).map(
                  (answer, index) => (
                    <AnswerBtn
                      selected={answer.text === selectedAnswer}
                      key={index}
                      onClick={() => {
                        props.updateAnswer(answer.text, answer.value);
                        setSelectedAnswer(answer.text);
                      }}
                    >
                      {answer.icon && (
                        <img
                          className="answer-icon"
                          src={require(`../assets/question-icons/${answer.icon}`)}
                          alt=""
                        />
                      )}

                      {answer.text}
                    </AnswerBtn>
                  )
                )}
            </div>

            {/* Bool */}
            {props.question.questionType === enumQuestionType.Bool && (
              <div className="bool-container">
                <Checkbox
                  classes={{ root: 'cbRoot' }}
                  defaultChecked={props.answer === 'לא' ? false : true}
                  onChange={(e) => {
                    const answers = JSON.parse(props.question.availableAnswers);
                    const yesAnswer = answers.find((a) => a.text === 'כן');
                    const noAnswer = answers.find((a) => a.text === 'לא');
                    let currentAnswer = noAnswer;
                    setChecked(e.target.checked);
                    if (!checked) currentAnswer = yesAnswer;
                    else currentAnswer = noAnswer;
                    props.updateAnswer(currentAnswer.text, currentAnswer.value);
                    setSelectedAnswer(currentAnswer.text);
                  }}
                ></Checkbox>
              </div>
            )}

            {/* Text */}
            {props.question.questionType === enumQuestionType.Text && (
              <textarea
                defaultValue={props.answer}
                onChange={(e) =>
                  props.updateAnswerDebounce(
                    e.target.value
                    // calcAnswerValueForTest(
                    //     props.question.idForTest,
                    //     e.target.value
                    // )
                  )
                }
              />
            )}
            {/* Numeric */}
            {props.question.questionType === enumQuestionType.Numeric && (
              <input
                className="q-type-numeric-input"
                type="number"
                min={
                  props.question.availableAnswers
                    ? JSON.parse(props.question.availableAnswers)?.[0]?.min
                    : 0
                }
                max={
                  props.question.availableAnswers
                    ? JSON.parse(props.question.availableAnswers)?.[1]?.max
                    : null
                }
                onKeyDown={ignoreNegativeValues}
                pattern="[0-9]*"
                onChange={(e) => {
                  props.updateAnswerDebounce(
                    e.target.value
                    // calcAnswerValueForTest(
                    //     props.question.idForTest,
                    //     e.target.value
                    // )
                  );
                }}
                placeholder="00"
                defaultValue={props.answer}
              />
            )}
            {/* Checklist */}
            {props.question.questionType === enumQuestionType.Checklist &&
              props.question.availableAnswers
                .split(',')
                .map((answer, index) => {
                  return (
                    <div key={index} className="q-type-checklist">
                      <input
                        id={index}
                        type="checkbox"
                        className=""
                        checked={checklistAnswers.includes(answer)}
                        onChange={(e) =>
                          handleChecklistQuestionOnChange(
                            props.question.availableAnswers.split(',')[index],
                            e.target.checked
                          )
                        }
                      />
                      <label htmlFor={index}>{answer}</label>
                    </div>
                  );
                })}
            {/* TimeInput */}
            {props.question.questionType === enumQuestionType.TimeInput && (
              <div className="q-type-time-input">
                <div>
                  <div>מספר ימים בשבוע</div>
                  <input
                    type="number"
                    onKeyDown={ignoreNegativeValues}
                    onChange={(e) => handleTimeInputOnChange(e, 'days')}
                    placeholder="00"
                    maxLength={2}
                    min={0}
                    max={7}
                    value={daysInputValue}
                    required={true}
                  />
                </div>
                <small className="description">
                  {props.question.availableAnswers}
                </small>
                <div>
                  <div>שעות</div>
                  <input
                    type="number"
                    onKeyDown={ignoreNegativeValues}
                    onChange={(e) => handleTimeInputOnChange(e, 'hours')}
                    placeholder="00"
                    maxLength={2}
                    min={0}
                    value={hoursTimeInputValue}
                    required={true}
                  />
                </div>
                <div>
                  <div>דקות</div>

                  <input
                    type="number"
                    onKeyDown={ignoreNegativeValues}
                    onChange={(e) => handleTimeInputOnChange(e, 'minutes')}
                    placeholder="00"
                    maxLength={2}
                    min={0}
                    value={minutesTimeInputValue}
                    required={true}
                    // ref={minutesTimeInputRef}
                  />
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </>
  ) : null;
}

Question.propTypes = {
  question: propTypes.object,
  answer: propTypes.string,
  updateAnswer: propTypes.func,
  updateAnswerDebounce: propTypes.func,
  isFocus: propTypes.bool
};
